<template>
  <section class="comments">
    <p class="text__bold text__center">Comments</p>
    <div class="flex__between comments--new">
      <textarea
        class="comments--new-text"
        name="new-comment"
        rows="2"
        cols="30"
        placeholder="Type a new comment"
        v-model="newComment.content"
      />
      <button class="btn btn__green" @click="submitComment">Send</button>
    </div>
    <div v-if="comments.length === 0" class="comments--empty text__center">
      <p>No comments yet</p>
    </div>
    <simplebar v-else class="comments--overflow" data-simplebar-auto-hide="false">
      <div class="comments--content">
        <transition-group name="comment">
          <p
            class="comments__grid"
            :class="commentClass(comment)"
            v-for="comment in comments"
            :key="comment.id"
          >
            <span class="flex__between">
              <span class="text__bold">{{ comment.commenter_name }}</span>
              <span class="text__small">{{ comment.submitted }}</span>
            </span>
            <span>{{ comment.content }}</span>
          </p>
        </transition-group>
      </div>
    </simplebar>
  </section>
</template>

<script>
import moment from "moment";
export default {
  props: ["comments", "service", "type", "name"],
  data() {
    return {
      newComment: {
        submitted: "",
        request_id: this.service.request_id,
        request_type: this.type,
        commenter_name: this.name,
        service_name: this.service.name,
        content: "",
        status_change: false
      }
    };
  },
  methods: {
    commentClass(comment) {
      return comment.status_change ? "comments--status" : null;
    },
    async submitComment() {
      if (this.newComment.content.trim() === "") {
        return this.flash(
          "Comment: Please type something in the comment box",
          "error"
        );
      }
      this.newComment.submitted = moment().format("MM-DD-YYYY h:mm:ss a");
      this.$emit("addComment", this.newComment);
      this.newComment.submitted = "";
      this.newComment.content = "";
    }
  }
};
</script>

<style scoped lang="scss">
</style>